<!--
 * @Author: shuchang
 * @Date: 2021-06-03 17:12:21
 * @LastEditors: shuchang
 * @LastEditTime: 2022-03-19 14:17:36
 * @Description: 
-->
<template>
  <el-container class="is-vertical">
      <left @getIframe="getIframe"></left>
     <el-container>
        <el-header>Header</el-header>
        <el-main>
            <iframe src="" frameborder="0" v-for="item in iframeList" :key="item.sysId"></iframe>
        </el-main>
    </el-container>
  </el-container>
</template>
<script>
    import Header from './Header.vue';
    import { mapGetters } from 'vuex'
    import left from './left';
    export default {
        name:'container',
        components:{
            Header,left
        },
        data(){
            return{
                iframeList:[]
            }
        },
        methods:{
            toClick:function(msg){
                // console.log(msg);
                this.$refs.child.toClick()
                
            },
            getIframe(data){
                console.log(data)
                // this.iframeList = data;
            }
        }
    }
</script>
<style lang="scss" scoped>
      .el-container, section{
          width: 100%;
          height: 100%;
          background: #ffffff;
          position: relative;
      }
      section{
          display: flex;
          height: calc(100% - 64px);
      }
      .el-aside{
        position: relative;
        z-index: 99;
      }
</style>
